<template>
  <div class="become-member-container">
    <!-- 会员选项 -->
    <div class="membership-options">
      <div
        v-for="option in membershipOptions"
        :key="option.id"
        class="membership-option"
        :class="{ 'selected': selectedOption === option.id }"
        @click="selectMembership(option.id)">
        <img :src="option.intervalUnit === 'MONTH'
                ? require('@/assets/member/month.png')
                : require('@/assets/member/year.png')"
             style="width: 50px; vertical-align: middle;">
        <div class="name">{{ option.name }}</div>
        <div class="price">
          <span class="price-amount">${{ fun(option.price) }}</span>
          <span class="price-unit">/{{ option.intervalUnit }}</span>
        </div>
        <div class="description">{{ option.description }}</div>
      </div>
    </div>

    <!-- PayPal支付按钮 -->
    <div class="payment-section">
      <h2 v-if="selectedOption">选择: {{ selectedOptionName }}</h2>

      <div v-if="selectedOption" class="paypal-container">
        <PayPalButton
          :amount="selectedPrice"
          :planid="selectedPlanid"
          :currency="currency"
          :description="selectedDescription"
          @payment-success="handlePaymentSuccess"
          @payment-error="handlePaymentError"
        />
      </div>


    </div>

    <!-- 支付状态提示 -->
    <div v-if="paymentStatus" class="payment-status" :class="paymentStatus.type">
      {{ paymentStatus.message }}
    </div>
  </div>
</template>

<script>
import PayPalButton from './PayPalButton.vue';
import * as curApi from "@/api/tcode/subscriptions";
export default {
  name: 'BecomeMember',
  components: {
    PayPalButton
  },
  data() {
    return {
      // 会员选项配置
      membershipOptions: [],
      selectedOption: null,
      currency: 'USD',
      paymentStatus: null
    };
  },
  computed: {
    // 当前选择的套餐名称
    selectedOptionName() {
      const option = this.membershipOptions.find(o => o.id === this.selectedOption);
      return option ? option.name : '';
    },
    // 当前选择的价格
    selectedPrice() {
      const option = this.membershipOptions.find(o => o.id === this.selectedOption);
      return option ? option.price : '0.00';
    },
    // 当前选择的Planid
    selectedPlanid() {
      const option = this.membershipOptions.find(o => o.id === this.selectedOption);
      return option ? option.id : '';
    },
    // 当前选择的描述
    selectedDescription() {
      const option = this.membershipOptions.find(o => o.id === this.selectedOption);
      return option ? option.description : '';
    },
    // 当前选择的类型(订阅/一次性)
    selectedType() {
      const option = this.membershipOptions.find(o => o.id === this.selectedOption);
      return option ? option.type : 'one-time';
    }
  },
  methods: {
    //初始化
    init() {
      curApi.getPlans('PROD-8PB59829KT130811P').then(result => {
        // 将接口获取的数据转换并放入 membershipOptions
        if (result.data && Array.isArray(result.data)) {
          this.membershipOptions = result.data.map(plan => ({
            id: plan.id || plan.planId,
            name: plan.name || plan.title,
            price: plan.fixedPrice,
            intervalUnit: plan.intervalUnit,
            description: plan.description || plan.desc,
            type: plan.type || 'subscription'
          }));
        }
        // 查找并默认选中月会员
        const monthlyPlan = this.membershipOptions.find(
          plan => plan.intervalUnit === 'MONTH'
        );
        if (monthlyPlan) {
          this.selectedOption = monthlyPlan.id;
        }
      }).catch(error => {
        console.error('Failed to obtain membership plan:', error);
      })
      //this.$refs.dialog.opened();
    },
    // 选择会员套餐
    selectMembership(optionId) {
      this.selectedOption = optionId;
      this.paymentStatus = null;
    },
    // 处理支付成功
    handlePaymentSuccess(payment) {
      this.paymentStatus = {
        type: 'success',
        message: '支付成功！您现在是我们的会员了。'
      };
    },
    // 处理支付错误
    handlePaymentError(error) {
      this.paymentStatus = {
        type: 'error',
        message: 'An error occurred during the payment process: ' + (error.message)
      };
    },

    fun(data){
      if (data == null || data == undefined || data == "" || data == 0) {
        return '0.00';
      }
      if (typeof (data) === 'number') {
        return (data).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      }
      return data;
    },
  }
  ,
  /**
   * 渲染前
   */
  created: function () {
    this.init();
  },
};
</script>

<style scoped>
.become-member-container {
  max-width: 700px;
  margin: 0 auto;
  padding: 20px;
}

.membership-options {
  display: flex;
  gap: 20px;
  margin-bottom: 30px
}

.membership-option {
  flex: 1;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex; /* 新增 */
  flex-direction: column; /* 新增 */
  align-items: center; /* 新增 - 使所有子元素水平居中 */
  text-align: center; /* 新增 - 使文本居中 */
  background: #F5F0FF;
  box-shadow: 0px 0px 10px 0px rgba(132,132,132,0.5);
  border-radius: 8px;
}

.membership-option:hover {
  border-color: #7200D6;
}

.membership-option.selected {
  border: 1px solid #7200D6;
  background-color: #f0f8ff;
}

.membership-option h3 {
  color: #333;
  margin-bottom: 10px;
}
.membership-option img {
  margin-bottom: 15px;
}
.membership-option .name {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
}

.membership-option .price {
  font-family: PingFangSC-Medium;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: 500;
  margin-top: 25px;
  margin-bottom: 25px;
}

.membership-option .price-amount {
  font-family: PingFangSC-Medium;
  font-size: 30px;
  color: #333333;
  letter-spacing: 0;
  line-height: 42px;
  font-weight: 500;
}

.membership-option .price-unit {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #333333;
  letter-spacing: 0;
  line-height: 42px;
  font-weight: 400;
}

.membership-option .description {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #333333;
  letter-spacing: 0;
  text-align: left; /* 关键修改：内容居左 */
  font-weight: 400;
  width: 100%; /* 占满宽度 */
  padding: 0 10px; /* 左右留白 */
  box-sizing: border-box; /* 包含padding在宽度内 */
}

.payment-section {
  margin-top: 30px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.paypal-container {
  margin-top: 20px;
}

.select-prompt {
  padding: 15px;
  background-color: #fff8e1;
  border-left: 4px solid #ffc107;
  color: #ff8f00;
}

.payment-status {
  margin-top: 20px;
  padding: 15px;
  border-radius: 4px;
}

.payment-status.success {
  background-color: #e8f5e9;
  color: #2e7d32;
  border-left: 4px solid #4caf50;
}

.payment-status.error {
  background-color: #ffebee;
  color: #c62828;
  border-left: 4px solid #f44336;
}
</style>



// WEBPACK FOOTER //
// src/pages/tcode/member/becomeMember.vue